import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProRoute({ children }) {
  const auth = useSelector((state) => state.auth);

  if (auth.loading) return null;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace />;
  if (auth.onboarding_complete === false) return <Navigate to="/setup" replace />;
  if (auth.plan === "free") return <Navigate to="/upgrade" replace />;
  return children;
}
